import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["barcodeColumn", "barcodeToggle", "totalsLabel"]
  static values = { barcodeVisible: Boolean }

  connect() {
    this.syncBarcodeVisibility()
  }

  toggleBarcode(event) {
    this.barcodeVisibleValue = event.currentTarget.checked
  }

  barcodeVisibleValueChanged() {
    this.syncBarcodeVisibility()
  }

  barcodeColumnTargetConnected(column) {
    this.setColumnVisibility(column)
  }

  syncBarcodeVisibility() {
    if (this.hasBarcodeToggleTarget) {
      this.barcodeToggleTarget.checked = this.barcodeVisibleValue
    }

    this.barcodeColumnTargets.forEach((column) => this.setColumnVisibility(column))

    if (this.hasTotalsLabelTarget) {
      this.totalsLabelTarget.colSpan = this.barcodeVisibleValue ? 7 : 6
    }
  }

  setColumnVisibility(column) {
    column.classList.toggle("hidden", !this.barcodeVisibleValue)
  }
}
